<template>
    <div class="part6 part">
        <div class="top" :class="{animate: isAnimate}">
            <div class="title" :class="{animate: isAnimate}">特色服务</div>
        </div>
        <div class="bottom">
          <el-row :gutter="30">
            <el-col :span="14">
              <div class="imgBox">
                <div class="imac" :class="{animate: isAnimate}">
                  <img src="../../static/images/iMac.png" alt="">
                </div>
                <div class="macbook" :class="{animate: isAnimate}">
                  <img src="../../static/images/MacBook.png" alt="">
                </div>
                <div class="line1 line" :class="{animate: isAnimate}">
                  <div class="drawLine"></div>
                </div>
                <div class="line2 line" :class="{animate: isAnimate}">
                  <div class="drawLine"></div>
                </div>
              </div>
            </el-col>
            <el-col :span="10">
              <div class="screen bigScreen" :class="{animate: isAnimate}">
                <h1>
                  网评数据可视化DataV大屏
                </h1>
                <p class="describe">
                    部门、人员、任务等三个维度的数据实时获取，处理过程实时追踪，多维度数据实时分析，数据可视化震撼呈现！
                </p>
              </div>
              <div class="screen smallScreen" :class="{animate: isAnimate}">
                <h1>
                  网评模拟对抗演练系统
                </h1>
                <p class="describe">
                    近乎真实的多类型多场景对战互动，使你从一名小白快速成长为团队核心。红蓝战队从签到集结到战术安排，从对抗演练到战况评估，全程动态可视化实时呈现！这既是一场眼明手快的“战争”，更是一次充满智慧的头脑风暴！
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
    </div>
</template>
<script>
export default {
    name :"Partsix",
    data(){
        return{
          isAnimate:false
        }
    },
    mounted:function(){
      document.addEventListener("scroll",this.actionAnima);
    },
    methods:{
      actionAnima:function(){
        let _self = this;
        const bodyH = document.body.scrollTop || document.documentElement.scrollTop;
        if(bodyH >= 3700){
          _self.isAnimate = true;
        }
      }
    }
}
</script>
<style scoped>
  .part6 .top{
    height: 132px;
    line-height: 132px;
    width: 540px;
    margin: 20px auto 10px auto;
    background: url(../../static/images/features.png) no-repeat;
    background-size: 100% auto;
    background-position: center top;
    text-align: center;
    font-size: 40px;
    /* border: 1px solid red; */
  }
  .part6 .top.animate{
    animation: topBgDown 0.5s linear forwards;
  }
	.part6 .top .title{
		position: relative;
		opacity: 0;
	}
  .part6 .top .title.animate{
    animation: topUp 0.6s linear forwards;
    animation-delay: 0.3s;
  }
  .part6 .bottom{
    width: 1200px;
    height:380px;
    margin:80px auto;
    /* border: 1px solid red; */
  }
  .part6 .bottom .imgBox{
    width: 100%;
    height:380px;
    position: relative;
    /* border: 1px solid green; */
  }
  .part6 .bottom .imgBox img{
    max-width: 100%;
		position: relative;
  }
  .part6 .bottom .imgBox .imac{
    position: absolute;
    z-index: 10;
    width: 438px;
		opacity: 0;
    /* border:1px solid #333; */
  }
  .part6 .bottom .imgBox .imac.animate{
    animation: bottomImgRight .5s linear forwards;
    animation-delay: 0.6s;
  }
  .part6 .bottom .imgBox .macbook{
    position: absolute;
    z-index: 20;
    top:126px;
    left: 200px;
    width: 438px;
    height: 250px;
    opacity: 0;
    /* border:1px solid blue; */
  }
  .part6 .bottom .imgBox .macbook.animate{
    animation: bottomImgRightBook .5s linear forwards;
    animation-delay: 0.9s;
  }
  .part6 .bottom .imgBox .line{
    position: absolute;
    z-index: 30;
    height: 5px;
    overflow: hidden;
  }
  .part6 .bottom .imgBox .line1{
    width: 0px;
    right: -20px;
    top: 35px;
  }
  .part6 .bottom .imgBox .line1.animate{
    animation: bottomLine1 1s linear forwards;
    animation-delay: 0.9s;
  }
  .part6 .bottom .imgBox .line2{
    right: -20px;
    top: 240px;
    width: 0px;
  }
  .part6 .bottom .imgBox .line2.animate{
    animation: bottomLine2 1s linear forwards;
    animation-delay: 0.9s;
  }
  .part6 .bottom .imgBox .drawLine{
    border: 1px dashed #ccc;
  }
  .part6 .bottom .screen{
    height: 190px;
    margin-left: 20px;
    position: relative;
  }
  .part6 .bottom .screen p.describe{
		margin-top: 20px;
    color: #666;
  }
	.part6 .bottom .bigScreen{
		opacity: 0;
	}
  .part6 .bottom .bigScreen.animate{
    animation: bottomTextLeft .5s linear forwards;
    animation-delay: 0.6s;
  }
	.part6 .bottom .smallScreen{
		opacity: 0;
	}
  .part6 .bottom .smallScreen.animate{
    animation: bottomTextLeft .5s linear forwards;
    animation-delay: 0.9s;
  }
	@keyframes topUp{
		from{
				top: 15px;
				opacity: 0;
		}to{
				top: 0px;
				opacity: 1;
		}
  }
	@keyframes topBgDown{
		from{
			background-position: center top;
		}to{
			background-position: center center;
		}
  }
	@keyframes bottomTextLeft{
		from{
				left: 15px;
				opacity: 0;
		}to{
				left: 0px;
				opacity: 1;
		}
  }
	@keyframes bottomImgRight{
		from{
				left: -15px;
				opacity: 0;
		}to{
				left: 0px;
				opacity: 1;
		}
  }
	@keyframes bottomImgRightBook{
		from{
				left: 185px;
				opacity: 0;
		}to{
				left: 200px;
				opacity: 1;
		}
  }
	@keyframes bottomLine1{
		from{
				width: 0px;
		}to{
				width: 230px;
		}
  }
	@keyframes bottomLine2{
		from{
				width: 0px;
		}to{
				width: 80px;
		}
  }
  @media (max-width: 1439px){
    .part6 p.center{
      width: 800px;
    }
    .part6 .bottom{
      width: 1000px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Partsix.vue